module.exports = __webpack_public_path__ + "static/media/2.3b2898b1.jpg";